import {
  EnhancedTableHead,
  EnhancedTableRows,
  getComparator,
  stableSort,
} from './DataTableHelper';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import './DataTable.css';

const DataTable = (props) => {
  const {t} = useTranslation();
  const [order, setOrder] = React.useState(props.defaultSort);
  const [orderBy, setOrderBy] = React.useState(props.defaultSortKey);
  const [page, setPage] = React.useState(0);
  const [visibleRows, setVisibleRows] = React.useState([]);
  const rowsPerPage = props.showPagination ? 10 : (props.rows || []).length;

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleRequestFilter = (filterValue, property) => {
    if (props.onRequestFilter) {
      props.onRequestFilter(filterValue, property);
    } else if (filterValue == t('ALL')) {
      setVisibleRows(props.rows);
    } else {
      const filtered = props.rows?.filter(
        (row) => row[property].value == filterValue
      );
      setVisibleRows(filtered);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const sortedRow = React.useMemo(
    () =>
      stableSort(props.rows || [], getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, props.rows]
  );

  React.useEffect(() => {
    setVisibleRows(sortedRow);
  }, [sortedRow]);

  return (
    <Box sx={{width: '100%'}}>
      <Paper sx={{width: '100%', mb: 2}}>
        <TableContainer id={'dataTableComponent'}>
          <Table
            sx={{minWidth: 750}}
            aria-labelledby="tableTitle"
            size={'medium'}
          >
            <EnhancedTableHead
              headCells={props.headCells}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              onRequestFilter={handleRequestFilter}
              rowCount={(props.rows || []).length}
            />
            <EnhancedTableRows
              visibleRows={visibleRows}
              rowAlignment={props.rowAlignment}
              defaultColSpan={6}
              noRecordFoundComponent={props.noRecordFoundComponent}
            ></EnhancedTableRows>
          </Table>
        </TableContainer>
        {visibleRows.length > 0 && props.showPagination ? (
          <TablePagination
            id="tablePagination2222"
            rowsPerPageOptions={[]}
            component="div"
            count={(props.rows || []).length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
          />
        ) : null}
      </Paper>
    </Box>
  );
};

DataTable.propTypes = {
  rows: PropTypes.array,
  onRequestFilter: PropTypes.func,
  rowAlignment: PropTypes.object,
};

export default DataTable;
